import DescriptionLeft from './description_left.js.jsx';
import DescriptionRight from './description_right.js.jsx';
import Gallery from './gallery.js.jsx';
import SpecialIcons from './special_icons.js.jsx';
import { IS_SANATORIUMS, IS_UBOOK } from '../../filter_main.js.jsx';

const $ = require('jquery');

export default class CampCard extends React.Component {
  constructor(props) {
    super(props);
    this.price_food_changed = this.price_food_changed.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);

    this.state = {
      min_price: null,
      min_price_without_discount: null,
      discount: null,
      bonuses: null,
      food_type_name: null,
      tariffCondition: null,
      selectedTariff: null,
    };
  }

  componentDidMount() {
    let card = this;
    let card_selector = $(`div#${this.props.data.id}`);
    card_selector.find('.camp_link').on('click', function (event) {
      if (!$(event.target).hasClass('reject_href')) {
        gtag('event', 'clickOnObject_onCategoryPage', {
          event_category: 'search',
          event_label: `${card.props.data.region_name}, name:${card.props.data.name}, instant:${card.props.data.is_can_instant_booking ? 'yes' : 'no'}`,
        });
      }
    });
  }

  price_food_changed(
    newPrice,
    newName,
    minPriceWithoutDiscount,
    discount,
    bonuses,
    tariffCondition,
    seats,
    selectedTariff
  ) {
    if (
      this.state.food_type_name !== newName ||
      this.state.min_price != newPrice ||
      this.state.min_price_without_discount != minPriceWithoutDiscount ||
      this.state.selectedTariff != selectedTariff ||
      this.state.tariffCondition != tariffCondition
    ) {
      this.setState({
        min_price: newPrice,
        food_type_name: newName,
        min_price_without_discount: minPriceWithoutDiscount,
        discount: discount,
        bonuses: bonuses,
        tariffCondition: tariffCondition,
        selectedTariff: selectedTariff,
      });
    }
  }

  handleFavoriteClick(e) {
    e.preventDefault();
    const { data, toggleFavoriteCamp } = this.props;
    toggleFavoriteCamp(data, $(this));
  }

  getDiscountTooltipText() {
    let campType = 'базой отдыха';
    if (IS_SANATORIUMS) campType = 'санаторием';
    else if (IS_UBOOK) campType = 'отелем';

    return `Указана максимальная скидка предоставляемая ${campType}. Размер скидки может варьироваться в зависимости от категории номера и выбранных дат.`;
  }

  render() {
    const apartmentProps = {
      display_calculated_price: this.props.display_calculated_price,
      filter_params: this.props.filter_params,
      count_guests: this.props.count_guests,
      children_ages: this.props.children_ages,
      delta_days: this.props.delta_days,
      seo_path: this.props.data.seo_path,
      data: this.props.data,
      count: this.props.count_apartments,
      apartments: this.props.apartments,
      currency_name: this.props.data.currency_name,
      filters: this.props.filters,
      price_food_changed: this.price_food_changed,
    };

    const descriptionLeftProps = {
      apartments: apartmentProps,
      data: this.props.data,
      filter_params: this.props.filter_params,
      showMapCamp: this.props.showMapCamp,
      showContractPercent: this.props.showContractPercent,
      showCommission: this.props.showCommission,
      food_type_name: this.state.food_type_name,
      tariffCondition: this.state.tariffCondition,
      selectedTariff: this.state.selectedTariff,
      vip_booking_phone: this.props.vip_booking_phone,
      is_nofollow: this.props.is_nofollow,
      show_all_camps: this.props.show_all_camps,
      campsLoaded: this.props.campsLoaded,
      min_price: this.state.min_price,
      filter_values: this.props.filter_values,
    };

    const descriptionRightProps = {
      have_autocompleted_price: this.props.data.have_autocompleted_price,
      show_outdated_price: this.props.data.show_outdated_price,
      score: this.props.data.rating,
      rating_style: this.props.data.rating_style,
      reviews_count_string: this.props.data.reviews_count_string,
      min_price: this.state.min_price,
      min_price_without_discount: this.state.min_price_without_discount,
      discount: this.state.discount,
      bonuses: this.state.bonuses,
      delta_days: this.props.delta_days,
      count_guests: this.props.count_guests,
      children_ages: this.props.children_ages,
      booking_url: this.props.data.booking_url,
      region_work_with: this.props.region_work_with,
      filter_params: this.props.filter_params,
      seo_path: this.props.data.seo_path,
      allCampsLoaded: this.props.allCampsLoaded,
      is_nofollow: this.props.is_nofollow,
      show_all_camps: this.props.show_all_camps,
      campsLoaded: this.props.campsLoaded,
      has_cashback: this.props.data.has_cashback,
      selectedTariff: this.state.selectedTariff,
      complex_placement: this.props.data.complex_placement,
    };

    return (
      <div
        className={`card-favorite ${this.props.data.is_vip ? 'card card_big card_top' : 'card card_big'}`}
        id={this.props.data.id}
      >
        <div className='card__thumb'>
          <div
            className='card__favorite-block'
            data-camp-id={this.props.data.id}
            data-favorited={this.props.isFavorite}
            onClick={this.handleFavoriteClick}
          >
            <div
              className={`favorite favorite-filter ${this.props.isFavorite ? 'unfavorite-icon' : 'favorite-icon'}`}
            ></div>
          </div>
          {this.state.discount > 0 && (
            <div className='card__discount-label tooltip'>
              <span>Скидка до {this.state.discount}%</span>
              <div className='icon icon-support_white icon-support_white-dims'></div>
              <span className='tooltiptext auto filter middle'>
                {this.getDiscountTooltipText()}
              </span>
            </div>
          )}
          <Gallery
            pics={this.props.pictures}
            filter_alt_img={this.props.filter_alt_img}
            rotateImages={this.props.data.is_vip}
          />
          <SpecialIcons is_new_year_offer={this.props.data.is_new_year_offer} />
        </div>
        <div className='card__desc'>
          <DescriptionLeft {...descriptionLeftProps} />
          <DescriptionRight {...descriptionRightProps} />
        </div>
      </div>
    );
  }
}
